import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../__styling'

export const TWContentBlock = styled.div<{
    backgroundColor?: string
    hasBottomPadding?: boolean
}>(({ backgroundColor, hasBottomPadding }) => ({
    padding: hasBottomPadding ? calcRem(32, 0) : calcRem(32, 0, 0, 0),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    backgroundColor: backgroundColor ?? 'white',

    [breakpoint('xs')]: {
        padding: hasBottomPadding ? calcRem(48, 0) : calcRem(48, 0, 0, 0),
    },
}))

export const TWContentSection = styled('div')(({ theme }) => ({
    padding: calcRem(0, 16),
    width: '100%',
    maxWidth: 1044,
    boxSizing: 'border-box',
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    gap: calcRem(24),

    [breakpoint('xs')]: {
        padding: calcRem(0, 32),
        gap: calcRem(32),
        flexDirection: 'row',
    },

    [breakpoint('sm')]: {
        gap: calcRem(100),
    },
}))

export const StyledMainContainer = styled('div')<{
    order?: number
    hasBottomPadding?: boolean
}>(({ order, hasBottomPadding }) => ({
    margin: 'auto 0',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: calcRem(16),
    order: 1,
    paddingBottom: 0,

    [breakpoint('xs')]: {
        gap: calcRem(24),
        order: order ?? 'initial',
        paddingBottom: hasBottomPadding ? calcRem(32) : calcRem(0),
        maxWidth: calcRem(320),
    },

    [breakpoint('sm')]: {
        maxWidth: calcRem(400),
    },
}))

export const StyledSupportContainer = styled('div')<{
    order?: number
    isBottomAligned?: boolean
}>(({ order, isBottomAligned }) => ({
    margin: isBottomAligned ? '0' : '0 auto',
    minWidth: 0,
    display: 'flex',
    flex: 1,
    order: 2,

    [breakpoint('xs')]: {
        order: order ?? 'initial',
    },
}))

export const StyledImage = styled('img')<{ isBottomAligned?: boolean }>(
    ({ isBottomAligned }) => ({
        marginLeft: 'auto',
        display: 'block',
        width: '100%',
        maxWidth: '100%',
        height: 'auto',
        alignSelf: isBottomAligned ? 'flex-end' : 'center',
    }),
)

export const StyledHeaderContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: calcRem(16),
})
export const StyledIconContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: calcRem(48),
    width: calcRem(48),
    borderRadius: 16,
    backgroundColor: 'rgba(4, 61, 226, 0.06)',
})

export const StyledHeader = styled('h2')(({ theme }) => ({
    color: theme.colors.text.primary,
    fontFamily: theme.fonts.heading,
    fontWeight: 400,
    fontSize: calcRem(28),
    lineHeight: calcRem(36),
    margin: 0,
    padding: 0,

    [breakpoint('sm')]: {
        fontSize: calcRem(32),
        lineHeight: calcRem(40),
    },
}))

export const StyledHeaderIntent = styled('span')({
    // Bold as serif font doesn't have a medium
    fontWeight: 700,
    fontStyle: 'italic',
})

export const StyledSubText = styled('p')(({ theme }) => ({
    color: theme.colors.text.secondary,
    fontFamily: theme.fonts.sansSerif,
    fontWeight: 400,
    fontSize: calcRem(18),
    lineHeight: calcRem(28),
    margin: 0,
    padding: 0,
}))
